module.exports = __webpack_public_path__ + "static/media/shape1_1.a2f7f79a.obj";